import { render, staticRenderFns } from "./Avize.vue?vue&type=template&id=5a2324eb"
import script from "./Avize.vue?vue&type=script&lang=js"
export * from "./Avize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports